import { render, staticRenderFns } from "./RegistrationsChartSection.vue?vue&type=template&id=4e8537e9&"
import script from "./RegistrationsChartSection.vue?vue&type=script&lang=js&"
export * from "./RegistrationsChartSection.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationsChartSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports